export default "__VITE_ASSET__BBST5gRH__"